module.exports = __webpack_public_path__ + "static/recording-elements1-c08177a5bbb7889b28490af3df755c37.png";